// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__JAaK4","text":"ErrorBoundary_text__EZYvx","btn":"ErrorBoundary_btn__M9k0x"};